<template>
	<div class="order-body">
		<ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li>预付货款专项充值</li>
		</ul>
		<Search :ids="ids" :customList="customList" :staffList="staffList" :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" @exportExcel="exportExcel"/>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/weiPrePayList/Search.vue'
import MainTable from '@/components/weiPrePayList/MainTable.vue'
export default {
	name: 'weiPrePayList',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			dataValue: [],
			AuthorityList: {
				'01_0009_0003_00': false
			},
			dateValue: [],
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			excelParams: {},
			ids: [],
			customList: [],
			staffList: [],
			customerCategoryId: '0',
			dateType: 0,
			number: '',
			staff: '',
			liquiDateFlag: -1,
			customer: '',
			product: '',
			spec: '',
			orderKey: '',
			orderBy: '',
			customerName: '',
			searchNumber: '',
			type: '',
			shopId: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-10')
		this.getAuthority('01_0009_0000_00')
		this.openPage()
	},
	mounted () {
		window.onresize = () => {
			return (() => {
				this.$nextTick(() => {
					this.$refs.table.$refs.table.doLayout()
				})
			})()
		}
	},
	methods: {
		goBack () {
			this.$router.push('/main/weiPay')
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			this.excelParams = {
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				// customerName: this.customerName,
				searchNumber: this.searchNumber,
				type: this.type,
				// shopId: this.shopId,
				page: this.page,
				size: this.size
			}
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.$refs.table.clear()
			this.dateValue = data.dateValue
			this.searchNumber = data.searchNumber
			this.type = data.type
			this.page = 1
			this.excelParams = {
				beginDate: data.dateValue.length > 0 ? data.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: data.dateValue.length > 0 ? data.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				searchNumber: data.searchNumber,
				type: data.type,
				page: 1,
				size: this.size
			}
			this.findOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/tenpay/payment/prepayment/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = '微企付明细(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		findOrderList () {
			let params = {
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				page: this.page,
				size: this.size,
				// customerName: this.customerName,
				searchNumber: this.searchNumber,
				// shopId: this.shopId,
				type: this.type
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/tenpay/payment/prepayment/list`,
				data: params
			}).then(res => {
				this.totalCount = res.data.count
				this.tableData = res.data.list
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.menu-box {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:50px;
		line-height: 50px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 50px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
		}
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
